import { useState, useEffect, Children } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, Input } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'

import { useWeb3React } from '@web3-react/core'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledRoundedDigit = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  background: ${({ theme }) => (theme.isDark ? '#141E31' : '#141e31')};
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 120px;
`

const StyledHardText = styled(Text)`
  color: ${({ theme }) => theme.colors.hardTextColor};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const StyledHr = styled.hr<{ winning: boolean }>`
  border-color: ${({ theme, winning }) => (winning ? '#171717' : theme.colors.hrColor)};
  border-size: 1px;
  border-style: solid;
  width: 90%;
  margin-top: 20px;
  z-index: 10;
`

const YourTickets = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'

  const { account, library } = useWeb3React()

  const [tickets, setTickets] = useState([])
  const [selectedTicket, setSelectedTicket] = useState(-1)
  const [ticketNumbers, setTicketNumbers] = useState([])
  const [winningTickets, setWinningTickets] = useState([])

  useEffect(() => {
    const interval = setInterval(() => {
      if (account && tickets.length > 0) {
        const contract = new ethers.Contract(contractAddress, abi, genericprovider)
        contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp) => {
          if (tickets.length < tokensOfOwnerResp[0].length) {
            const allTickets = tokensOfOwnerResp[0].map((tokenId) => tokenId.toNumber())
            setTickets(allTickets)
            setSelectedTicket(allTickets.length - 1)
            contract.functions.currentCycle().then((currentCycleResp) => {
              const currentCycle = currentCycleResp[0].toNumber()
              contract.functions.totalSupplyAtCycle(currentCycle - 1).then((totalSupplyAtCycleResp) => {
                const startTokenId = totalSupplyAtCycleResp[0].toNumber() + 1
                contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp_) => {
                  const inactiveRoundTickets = tokensOfOwnerResp_[0].reduce((acc, tokenId) => {
                    if (tokenId < startTokenId) {
                      acc.push(tokenId)
                    }
                    return acc
                  }, [])

                  try {
                    const ticketChunks = []
                    while (inactiveRoundTickets.length) {
                      ticketChunks.push(inactiveRoundTickets.splice(0, 100)) // chunking into 100 tickets list.
                    }
                    const promises = []
                    for (let i = 0; i < ticketChunks.length; i++) {
                      promises.push(contract.functions.getMultipleTokensPrizes(ticketChunks[i]))
                    }
                    Promise.all(promises)
                      .then((results) => {
                        const localticketes = results.reduce((acc, res) => {
                          res[1].reduce((acc2, tokenId) => {
                            if (tokenId.toNumber() > 0) {
                              acc2.push(tokenId.toNumber())
                            }
                            return acc2
                          }, acc)
                          return acc
                        }, [])
                        setWinningTickets(localticketes)
                      })
                      .catch((err) => {
                        if (err) {
                          console.log(err)
                        }
                      })
                  } catch (err) {
                    if (err) {
                      console.log(err)
                    }
                  }
                })
              })
            })
          }
        })
      }
    }, 10000)
    return () => clearInterval(interval)
  }, [tickets, account])

  useEffect(() => {
    if (selectedTicket !== -1 && selectedTicket < tickets.length) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions.getTicketNumbers(tickets[selectedTicket]).then((getTicketNumbersResp) => {
        setTicketNumbers(getTicketNumbersResp[0].map((num) => num.toNumber()))
      })
    }
  }, [selectedTicket])

  useEffect(() => {
    if (account) {
      const contract = new ethers.Contract(contractAddress, abi, genericprovider)
      contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp) => {
        const allTickets = tokensOfOwnerResp[0].map((tokenId) => tokenId.toNumber())
        setTickets(allTickets)
        if (allTickets.length > 0) {
          setSelectedTicket(allTickets.length - 1)
          contract.functions.currentCycle().then((currentCycleResp) => {
            const currentCycle = currentCycleResp[0].toNumber()
            contract.functions.totalSupplyAtCycle(currentCycle - 1).then((totalSupplyAtCycleResp) => {
              const startTokenId = totalSupplyAtCycleResp[0].toNumber() + 1
              contract.functions.tokensOfOwner(account).then((tokensOfOwnerResp_) => {
                const inactiveRoundTickets = tokensOfOwnerResp_[0].reduce((acc, tokenId) => {
                  if (tokenId < startTokenId) {
                    acc.push(tokenId)
                  }
                  return acc
                }, [])

                try {
                  const ticketChunks = []
                  while (inactiveRoundTickets.length) {
                    ticketChunks.push(inactiveRoundTickets.splice(0, 100)) // chunking into 100 tickets list.
                  }
                  const promises = []
                  for (let i = 0; i < ticketChunks.length; i++) {
                    promises.push(contract.functions.getMultipleTokensPrizes(ticketChunks[i]))
                  }
                  Promise.all(promises)
                    .then((results) => {
                      const localtickets = results.reduce((acc, res) => {
                        res[1].reduce((acc2, tokenId) => {
                          if (tokenId.toNumber() > 0) {
                            acc2.push(tokenId.toNumber())
                          }
                          return acc2
                        }, acc)
                        return acc
                      }, [])
                      setWinningTickets(localtickets)
                    })
                    .catch((err) => {
                      if (err) {
                        console.log(err)
                      }
                    })
                } catch (err) {
                  if (err) {
                    console.log(err)
                  }
                }
              })
            })
          })
        }
      })
    }
  }, [account])

  return (
    <StyledCard style={{ flexDirection: 'column' }}>
      <Flex style={{ marginTop: 20, width: '90%' }}>
        <StyledHardText bold style={{ flexGrow: 1 }}>
          Your Tickets
        </StyledHardText>
        <Flex style={{ gap: 8 }}>
          <StyledHardText bold>Ticket:</StyledHardText>
          <StyledSoftText
            style={{
              background: theme.isDark ? '#334467' : '',
              borderRadius: 10,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <Input
              style={{
                display: 'inline',
                fontSize: 16,
                width: 40,
                height: 20,
                margin: 0,
                padding: 0,
                paddingLeft: 3,
                paddingRight: 3,
                textAlign: 'center',
                background: 'transparent',
                border: 'none',
                color: selectedTicket + 1 > tickets.length ? 'red' : theme.isDark ? 'white' : 'black',
                outline: 'none',
                borderWidth: 0,
              }}
              value={selectedTicket + 1}
              onChange={(e) => {
                e.preventDefault()
                try {
                  const value = e.target.value
                  if (value.match(/^[0-9]*$/)) {
                    setSelectedTicket(+value - 1)
                  }
                } catch (err) {
                  console.log(err)
                }
              }}
            />
          </StyledSoftText>
          <svg
            onClick={() => {
              setTicketNumbers([])
              setSelectedTicket(selectedTicket - 1)
            }}
            style={{
              marginTop: 7,
              visibility: selectedTicket <= 0 || selectedTicket + 1 > tickets.length ? 'hidden' : 'visible',
            }}
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 4L2 4"
              stroke={theme.isDark ? 'white' : 'black'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 7L1 4L4 1"
              stroke={theme.isDark ? 'white' : 'black'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            onClick={() => {
              setTicketNumbers([])
              setSelectedTicket(selectedTicket + 1)
            }}
            style={{
              marginTop: 7,
              visibility:
                selectedTicket === tickets.length - 1 || selectedTicket + 1 > tickets.length ? 'hidden' : 'visible',
            }}
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4L10 4"
              stroke={theme.isDark ? 'white' : 'black'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 7L11 4L8 1"
              stroke={theme.isDark ? 'white' : 'black'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Flex>
      </Flex>
      <StyledHr winning={false} style={{ marginBottom: 60 }} />
      <Flex
        style={{
          marginBottom: 40,
          flexDirection: 'column',
          position: 'relative',
          width: '90%',
          maxWidth: 380,
          justifyContent: 'center',
        }}
      >
        <Flex style={{ zIndex: 10, width: '100%' }}>
          <StyledSoftText style={{ flexGrow: 1, marginTop: 10, color: '#171717' }} bold>
            {winningTickets.includes(tickets[selectedTicket]) ? 'Winner!' : <>&nbsp;</>}
          </StyledSoftText>
          <StyledSoftText style={{ marginTop: 10 }}>&nbsp;</StyledSoftText>
        </Flex>
        <StyledHr
          winning={winningTickets.includes(tickets[selectedTicket])}
          style={{ width: '100%', borderStyle: 'dashed' }}
        />
        <Flex style={{ marginTop: 5, marginBottom: 16, zIndex: 10, gap: 4, justifyContent: 'center' }}>
          {tickets.length > 0 ? (
            ticketNumbers.length > 0 ? (
              Children.toArray(
                ticketNumbers.map((ticketNumber) => <StyledRoundedDigit>{ticketNumber}</StyledRoundedDigit>),
              )
            ) : (
              <StyledHardText style={{ marginTop: 12, marginBottom: 4 }}>Loading...</StyledHardText>
            )
          ) : (
            <StyledHardText style={{ marginTop: 12, marginBottom: 4 }}>No tickets yet</StyledHardText>
          )}
        </Flex>
        {winningTickets.includes(tickets[selectedTicket]) ? (
          <svg
            style={{ position: 'absolute', zIndex: '1', left: '-10%' }}
            width="120%"
            viewBox="0 0 352 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_bdi_1_1762)">
              <path
                d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
                fill="url(#paint0_radial_1_1762)"
                fillOpacity="0.52"
              />
              <path
                d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
                fill="url(#paint1_linear_1_1762)"
              />
              <path
                d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
                stroke="#3B496A"
                strokeOpacity="0.42"
              />
              <path
                d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
                stroke="url(#paint2_linear_1_1762)"
              />
            </g>
            <defs>
              <filter
                id="filter0_bdi_1_1762"
                x="0"
                y="-4"
                width="352"
                height="128"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_1762" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0584954 0 0 0 0 0.0778858 0 0 0 0 0.116667 0 0 0 0.12 0"
                />
                <feBlend mode="normal" in2="effect1_backgroundBlur_1_1762" result="effect2_dropShadow_1_1762" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1_1762" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0" />
                <feBlend mode="normal" in2="shape" result="effect3_innerShadow_1_1762" />
              </filter>
              <radialGradient
                id="paint0_radial_1_1762"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(176 -117.833) rotate(90) scale(287.5 862.5)"
              >
                <stop stopColor="#364366" />
                <stop offset="1" stopColor="#273255" />
              </radialGradient>
              <linearGradient id="paint1_linear_1_1762" x1="12" y1="58" x2="340" y2="58" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE259" />
                <stop offset="1" stopColor="#FFA751" />
              </linearGradient>
              <linearGradient id="paint2_linear_1_1762" x1="12" y1="58" x2="340" y2="58" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE259" />
                <stop offset="1" stopColor="#FFA751" />
              </linearGradient>
            </defs>
          </svg>
        ) : theme.isDark ? (
          <svg
            style={{ position: 'absolute', zIndex: '1', left: '-10%' }}
            width="120%"
            viewBox="0 0 352 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_bdi_1_1762)">
              <path
                d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
                fill="url(#paint0_radial_1_1762)"
                fillOpacity="0.52"
                shapeRendering="crispEdges"
              />
              <path
                d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
                stroke="#3B496A"
                strokeOpacity="0.42"
                shapeRendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_bdi_1_1762"
                x="0"
                y="-4"
                width="352"
                height="128"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_1762" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0584954 0 0 0 0 0.0778858 0 0 0 0 0.116667 0 0 0 0.12 0"
                />
                <feBlend mode="normal" in2="effect1_backgroundBlur_1_1762" result="effect2_dropShadow_1_1762" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1_1762" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0" />
                <feBlend mode="normal" in2="shape" result="effect3_innerShadow_1_1762" />
              </filter>
              <radialGradient
                id="paint0_radial_1_1762"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(176 -117.833) rotate(90) scale(287.5 862.5)"
              >
                <stop stopColor="#364366" />
                <stop offset="1" stopColor="#273255" />
              </radialGradient>
            </defs>
          </svg>
        ) : (
          <svg
            style={{ position: 'absolute', zIndex: '1', left: '-10%' }}
            width="120%"
            viewBox="0 0 352 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_bdi_1_2893)">
              <path
                d="M12 12C12 9.79086 13.7909 8 16 8H336C338.209 8 340 9.79086 340 12V43.2488C340 44.1562 339.691 45.0367 339.125 45.7456L337.5 47.7795C333.057 53.3408 332.822 61.1689 336.924 66.9866L339.269 70.3129C339.745 70.9874 340 71.7926 340 72.6179V104C340 106.209 338.209 108 336 108H16C13.7909 108 12 106.209 12 104V72.6815C12 71.8169 12.2802 70.9755 12.7986 70.2834L14.8143 67.5925C19.0735 61.9067 19.0735 54.0933 14.8143 48.4075L12.7986 45.7166C12.2802 45.0245 12 44.1831 12 43.3184V12Z"
                fill="url(#paint0_radial_1_2893)"
                fillOpacity="0.52"
                shapeRendering="crispEdges"
              />
              <path
                d="M12.5 12C12.5 10.067 14.067 8.5 16 8.5H336C337.933 8.5 339.5 10.067 339.5 12V43.2488C339.5 44.0428 339.23 44.8132 338.734 45.4335L337.109 47.4674C332.527 53.2025 332.285 61.2752 336.515 67.2747L338.86 70.601C339.277 71.1912 339.5 71.8957 339.5 72.6179V104C339.5 105.933 337.933 107.5 336 107.5H16C14.067 107.5 12.5 105.933 12.5 104V72.6815C12.5 71.925 12.7452 71.1887 13.1988 70.5832L15.2145 67.8923C19.6068 62.0288 19.6068 53.9712 15.2145 48.1077L13.1988 45.4168C12.7452 44.8113 12.5 44.075 12.5 43.3184V12Z"
                stroke="#EDEDED"
                strokeOpacity="0.42"
                shapeRendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_bdi_1_2893"
                x="0"
                y="-4"
                width="352"
                height="128"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2893" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0584954 0 0 0 0 0.0778858 0 0 0 0 0.116667 0 0 0 0.12 0"
                />
                <feBlend mode="normal" in2="effect1_backgroundBlur_1_2893" result="effect2_dropShadow_1_2893" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1_2893" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0" />
                <feBlend mode="normal" in2="shape" result="effect3_innerShadow_1_2893" />
              </filter>
              <radialGradient
                id="paint0_radial_1_2893"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(176 -117.833) rotate(90) scale(287.5 862.5)"
              >
                <stop stopColor="#F5F6F8" />
                <stop offset="1" stopColor="#E8E8E8" />
              </radialGradient>
            </defs>
          </svg>
        )}
      </Flex>
    </StyledCard>
  )
}

export default YourTickets
